// extracted by mini-css-extract-plugin
export default {"tableFooter":"PromocodesTable_tableFooter__cZRxB","tableHead":"PromocodesTable_tableHead__+xxpA"};